var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pickup-filters-list" }, [
    _c("div", { staticClass: "pickup-filters-list__group" }, [
      _c("div", { staticClass: "pickup-filters-list__group-label" }, [
        _vm._v("\n      Тип\n    ")
      ]),
      _c(
        "div",
        { staticClass: "pickup-filters-list__group-list" },
        [
          _c("ui-checkbox", {
            attrs: { value: _vm.value.store, label: "Магазин" },
            on: {
              input: function($event) {
                return _vm.onInput("store", $event)
              }
            }
          }),
          _c("ui-checkbox", {
            attrs: { value: _vm.value.terminal, label: "Постамат" },
            on: {
              input: function($event) {
                return _vm.onInput("terminal", $event)
              }
            }
          }),
          _c("ui-checkbox", {
            attrs: { value: _vm.value.pickup, label: "ПВЗ" },
            on: {
              input: function($event) {
                return _vm.onInput("pickup", $event)
              }
            }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "pickup-filters-list__group" }, [
      _c("div", { staticClass: "pickup-filters-list__group-label" }, [
        _vm._v("\n      Услуги\n    ")
      ]),
      _c(
        "div",
        { staticClass: "pickup-filters-list__group-list" },
        [
          _c("ui-checkbox", {
            attrs: { value: _vm.value.fitting, label: "Есть примерка" },
            on: {
              input: function($event) {
                return _vm.onInput("fitting", $event)
              }
            }
          }),
          _c("ui-checkbox", {
            attrs: { value: _vm.value.returns, label: "Есть возврат" },
            on: {
              input: function($event) {
                return _vm.onInput("returns", $event)
              }
            }
          }),
          _c("ui-checkbox", {
            attrs: { value: _vm.value.cardPay, label: "Оплата картой" },
            on: {
              input: function($event) {
                return _vm.onInput("cardPay", $event)
              }
            }
          }),
          _c("ui-checkbox", {
            attrs: { value: _vm.value.dayAndNight, label: "Круглосуточно" },
            on: {
              input: function($event) {
                return _vm.onInput("dayAndNight", $event)
              }
            }
          }),
          _c("ui-checkbox", {
            attrs: { value: _vm.value.withoutPrepay, label: "Без предоплаты" },
            on: {
              input: function($event) {
                return _vm.onInput("withoutPrepay", $event)
              }
            }
          }),
          _c("ui-checkbox", {
            attrs: { value: _vm.value.withoutQrCode, label: "Без QR-кода" },
            on: {
              input: function($event) {
                return _vm.onInput("withoutQrCode", $event)
              }
            }
          })
        ],
        1
      )
    ]),
    _vm.countActiveFilters
      ? _c(
          "button",
          {
            staticClass: "pickup-filters-list__reset-btn",
            on: { click: _vm.resetFilters }
          },
          [_vm._v("\n    Сбросить фильтры\n  ")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }